import { Tag } from 'antd'
import AttributesCell from './AttributesCell'
import RelationCell from './RelationCell'
import EditingAttributeCell from './EditingAttributeCell'
import { getNodeLabel } from 'Services/WeaverUtils'

CellContents = ({
  dataType,
  isEditing,
  isEmpty,
  isFetching,
  isReadOnly,
  isRelationCol,
  contents,
  r,
  c,
  relationsMap
}) ->

  if isEditing and !isReadOnly
    if isRelationCol
      <RelationCell
        defaultValue={contents}
        r={r}
        c={c}
      />
    else
      <EditingAttributeCell
        defaultValue={contents}
        dataType={dataType}
        r={r}
        c={c}
      />
  else if isRelationCol
    if contents?[0]
      [id, ...rest] = contents
      <>
        <Tag key={id}>
          { getNodeLabel(relationsMap[id]) }
        </Tag>
        {if rest.length > 0
          <Tag key={id + "-rest"}>
            + { rest.length } ...
          </Tag>
        }
      </>
    else
      <></>
  else
    <AttributesCell contents={contents} dataType={dataType} />

export default CellContents
